import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLBorders = () => {
  return (
    <div className="html-container">
      <h1>HTML – Borders</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          HTML borders define the edges of elements such as divs, tables, images, and paragraphs. Borders can enhance layout, separate content, or improve visual design.
        </p>
      </section>

      {/* 2. Border Properties */}
      <section id="border-properties">
        <h2>2. Border Properties</h2>
        <ul>
          <li><code>border-width</code> – Sets the thickness of the border.</li>
          <li><code>border-style</code> – Defines the style of the border (solid, dashed, dotted, double, groove, ridge, inset, outset, none).</li>
          <li><code>border-color</code> – Sets the color of the border.</li>
          <li><code>border-radius</code> – Rounds the corners of the border.</li>
          <li><code>border-top / border-right / border-bottom / border-left</code> – Apply borders to specific sides.</li>
        </ul>
      </section>

      {/* 3. Basic Example */}
      <section id="basic-example">
        <h2>3. Basic Example</h2>
        <pre>
          <code>{`<div style="border: 2px solid #007bff; padding: 10px;">
  This div has a solid blue border.
</div>`}</code>
        </pre>
      </section>

      {/* 4. Border Styles */}
      <section id="border-styles">
        <h2>4. Border Styles</h2>
        <ul>
          <li><code>solid</code> – Single solid line.</li>
          <li><code>dashed</code> – Dashed line.</li>
          <li><code>dotted</code> – Dotted line.</li>
          <li><code>double</code> – Two lines.</li>
          <li><code>groove</code> – 3D groove effect.</li>
          <li><code>ridge</code> – 3D ridge effect.</li>
          <li><code>inset</code> – Makes the box look embedded.</li>
          <li><code>outset</code> – Makes the box look raised.</li>
        </ul>
      </section>

      {/* 5. Border Widths */}
      <section id="border-widths">
        <h2>5. Border Widths</h2>
        <p>Set the thickness of borders:</p>
        <pre>
          <code>{`<div style="border: 1px solid black;">1px border</div>
<div style="border: 3px solid black;">3px border</div>
<div style="border: 5px solid black;">5px border</div>`}</code>
        </pre>
      </section>

      {/* 6. Border Colors */}
      <section id="border-colors">
        <h2>6. Border Colors</h2>
        <p>You can use color names, hex codes, RGB, or HSL values:</p>
        <pre>
          <code>{`<div style="border: 2px solid red;">Red border</div>
<div style="border: 2px solid #00ff00;">Green border</div>
<div style="border: 2px solid rgb(0,0,255);">Blue border</div>`}</code>
        </pre>
      </section>

      {/* 7. Rounded Corners */}
      <section id="rounded-corners">
        <h2>7. Rounded Corners</h2>
        <p>Use <code>border-radius</code> to round corners:</p>
        <pre>
          <code>{`<div style="border: 2px solid #007bff; border-radius: 10px; padding: 10px;">
  Rounded corners
</div>

<div style="border: 2px solid #007bff; border-radius: 50%; width: 100px; height: 100px;">
  Circle
</div>`}</code>
        </pre>
      </section>

      {/* 8. Shorthand Borders */}
      <section id="shorthand">
        <h2>8. Shorthand Borders</h2>
        <p>You can define width, style, and color in one line:</p>
        <pre>
          <code>{`<div style="border: 3px dashed #ff5733; padding: 10px;">
  Dashed orange border
</div>`}</code>
        </pre>
      </section>

      {/* 9. Individual Sides */}
      <section id="individual-sides">
        <h2>9. Individual Sides</h2>
        <p>Apply different borders to each side:</p>
        <pre>
          <code>{`<div style="
  border-top: 3px solid red;
  border-right: 2px dotted green;
  border-bottom: 4px double blue;
  border-left: 1px dashed black;
  padding: 10px;
">
  Different borders on each side
</div>`}</code>
        </pre>
      </section>

      {/* 10. Summary */}
      <section id="summary">
        <h2>10. Summary</h2>
        <ul>
          <li>Borders define edges of HTML elements.</li>
          <li>Use <code>border-width</code>, <code>border-style</code>, <code>border-color</code> for customization.</li>
          <li><code>border-radius</code> rounds corners for better visuals.</li>
          <li>Shorthand syntax simplifies border definition.</li>
          <li>Different borders can be applied to each side individually.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLBorders;
